import { render } from "./video-recommend-skeleton.vue?vue&type=template&id=33fcaf54&scoped=true"
import script from "./video-recommend-skeleton.vue?vue&type=script&lang=js"
export * from "./video-recommend-skeleton.vue?vue&type=script&lang=js"

import "./video-recommend-skeleton.vue?vue&type=style&index=0&id=33fcaf54&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fcaf54"]])

export default __exports__